import React from 'react';
import { RatingBar } from '@ubeya/shared-web/components';
import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';

const RatingRenderer = ({ rowData, columnData: { onChangeRating, readOnly = false, hideZeroRating = false } }) => {
  const { summarized, subRows, isJob, isPto, isLeave, rating, employee } = rowData;

  const ratingChangeHandler = (newRating) => {
    const actualValue = newRating === rating ? null : newRating;
    onChangeRating({ ...rowData, value: actualValue });
    const employeeId = employee?.id;
    if (employeeId) {
      trackEvent('Star rating changed', {
        employee_id: employeeId,
        star_rating: actualValue,
        module: 'Payroll'
      });
    }
  };

  if (summarized || subRows || isJob || isPto || isLeave) {
    return <></>;
  }

  return (
    <RatingBar
      isLocked={readOnly}
      center={false}
      rating={rating}
      hideZeroRating={hideZeroRating}
      onChange={ratingChangeHandler}
    />
  );
};

export default RatingRenderer;
